import React from 'react';
import PropTypes from 'prop-types';
import ChatIcon from '../../../../../assets/SelectChatIcon';
import Hidden from '@material-ui/core/Hidden/Hidden';
import Translate from '../../../../../components/Translate';
import ImagesViewer from '../../../../../components/ImagesViewer';
import VideoViewer from '../../../../../components/VideoViewer';
import LoadingComponent from '../../../../../assets/LoadingComponent';
import ConversationHeader from './ConversationHeader';
import MessageList from './MessageList';
import MessageInputWithRef from './MessageInput';
import {FileMapper} from '../../../../../utils/FileService';
import '../chat-css/Conversation.css';
import {dummyTrue} from '../../../../../utils/General';
import {getCustomTemplates, getTemplates} from "../../../../../services/company/api";
import config from 'config';
import {moveConversationToManagedList} from "../../../../../services/chat/api";
import BlueButton from "../../../../../components-new/buttons/BlueButton";
import {addNotification as addNotificationAction} from "../../../../../services/notification/action";
import {connect} from "react-redux";


class Conversation extends React.Component {
    constructor(props) {
        super(props);
        this.childRef = React.createRef();
        this.state = {
            isImageViewerOpen: false,
            imageViewerPhotoIndex: 0,
            isVideoViewerOpen: false,
            videoAttachment: null,
            templates: [],
            sugTemplates: [],
            showSearchDiv: false,
            showMediaViewDiv: false,
            activeIndex: -1,
            replyTo: null
        };
    }

    setReplyTo = (message) => {
        this.setState({replyTo: message});
    }

    componentDidMount() {
        this.fetchTemplates();
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.conversation.id !== this.props.conversation.id) {
            this.fetchTemplates();
            this.setState({
                sugTemplates: [],
                activeIndex: -1
            });
        }
    }

    componentWillUnmount() {
        const {onUnMount} = this.props;
        onUnMount();
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    fetchTemplates = () => {
        const {conversation, readOnly} = this.props;
        if (!readOnly) {
            if (conversation && conversation.platform !== config.platformsMap.company && conversation.companyId && conversation.status !== config.conversationStatuses.botClosed) {
                Promise.all([
                    getTemplates(conversation.companyId),
                    getCustomTemplates()
                ])
                    .then(([templates, customTemplates]) => {
                        this.setState({templates: [...templates, ...customTemplates]});
                    })
                    .catch((error) => {
                        console.error("Error fetching templates:", error);
                    });
            }
        }
    }

    updateTemplates = (newTemplate) => {
        this.setState(prev => ({
            templates: [...prev.templates, newTemplate]
        }));
    }

    getAttachments = (type) => {
        const {conversation} = this.props;
        const {messages} = conversation;
        const typeMessages = messages.filter((message) => message.attachment && message.type === type);
        return typeMessages.map((message) =>
            Object.assign({}, message.attachment, {
                date: message.sentAt,
                id: message.messageId,
            })
        );
    };

    closeImageViewer = () => {
        this.setState({
            isImageViewerOpen: false,
            imageViewerPhotoIndex: 0,
        });
    };

    openImageViewer = (imageAttachment) => {
        const imageAttachments = this.getAttachments(FileMapper.image);
        const photoIndex = imageAttachments.findIndex((curImageAttachment) => curImageAttachment.url === imageAttachment.url);

        this.setState({
            isImageViewerOpen: true,
            imageViewerPhotoIndex: photoIndex,
        });
    };

    closeVideoViewer = () => {
        this.setState({
            isVideoViewerOpen: false,
        });
    };

    setSugTemplates = (data) => {
        this.setState({sugTemplates: data})
    }

    callChildFunction = (text) => {
        if (this.childRef.current) {
            this.childRef.current.selectTemplate(text);
        }
    };

    toggleSearchDiv = () => {
        const {showMediaViewDiv} = this.state;
        if (showMediaViewDiv) {
            this.setState({showMediaViewDiv: false})
        }

        this.setState(prev => ({showSearchDiv: !prev.showSearchDiv}));
    };

    toggleMediaViewDiv = () => {
        const {showSearchDiv} = this.state;
        if (showSearchDiv) {
            this.setState({showSearchDiv: false})
        }

        this.setState(prev => ({showMediaViewDiv: !prev.showMediaViewDiv}));
    };

    showConversationHistory = (conversationInfo) => {
        const {selectConversation} = this.props;
        selectConversation({
            id: conversationInfo.id,
            companyId: conversationInfo.companyId,
            platform: conversationInfo.platform,
            userFirstName: conversationInfo.userFirstName,
            userLastName: conversationInfo.userLastName,
        });
    };

    handleKeyDown = (e) => {
        const {sugTemplates} = this.state;
        const {activeIndex} = this.state;

        if (!Array.isArray(sugTemplates) || sugTemplates.length === 0) return;

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            const nextIndex = (activeIndex + 1) % sugTemplates.length;
            this.setState({activeIndex: nextIndex}, this.scrollToActive);
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            const prevIndex = (activeIndex - 1 + sugTemplates.length) % sugTemplates.length;
            this.setState({activeIndex: prevIndex}, this.scrollToActive);
        } else if (e.key === 'Enter' && activeIndex !== -1) {
            e.preventDefault();
            const selected = sugTemplates[activeIndex];
            if (selected) {
                this.callChildFunction(selected.text);
                this.setState({activeIndex: -1});
            }
        }
    };

    scrollToActive = () => {
        const el = document.getElementById(`sug-template-${this.state.activeIndex}`);
        if (el) el.scrollIntoView({behavior: 'smooth', block: 'nearest'});
    };

    render() {
        let {
            conversation,
            sendChatMessage,
            endConversationForOperator,
            openForwardDialog,
            openContactList,
            user,
            loadOlderMessages,
            showSideBar,
            readOnly,
            hasBackButton,
            company,
            confirmAction,
            ticketClick,
            blockUserClick,
            filteredMembers,
            forwardDialog,
            closeForwardDialog,
            forwardConversation,
            tariff,
            addNotification,
            hotkeys,
        } = this.props;
        const {
            isImageViewerOpen,
            imageViewerPhotoIndex,
            isVideoViewerOpen,
            videoAttachment,
            templates,
            sugTemplates,
            showSearchDiv,
            showMediaViewDiv
        } = this.state;
        const {messages, messagesTotalNumber, loadingOlderMessages} = conversation;

        const {loading} = conversation;

        if (loading) {
            return <LoadingComponent/>;
        }

        if (conversation.id === null && !readOnly) {
            return <NoConversationSelectedView openContactList={openContactList}/>;
        }

        if (!conversation.chatId) { // important check
            readOnly = true
        }

        return (
            <div className="conversation full-height" style={{borderRadius: '10px'}}>
                <div className="content">

                    <div className="header-wrapper">
                        <ConversationHeader
                            showConversationHistory={this.showConversationHistory}
                            hotkeys={hotkeys}
                            toggleSearchDiv={this.toggleSearchDiv}
                            toggleMediaViewDiv={this.toggleMediaViewDiv}
                            tariff={tariff}
                            company={company}
                            hasBackButton={hasBackButton}
                            conversation={conversation}
                            endConversation={endConversationForOperator}
                            openForwardDialog={openForwardDialog}
                            openContactList={openContactList}
                            readOnly={readOnly}
                            user={user}
                            ticketClick={ticketClick}
                            blockUserClick={blockUserClick}
                            filteredMembers={filteredMembers}
                            state={forwardDialog}
                            close={closeForwardDialog}
                            forwardConversation={forwardConversation}
                        />
                    </div>
                    <div className="messages-wrapper">
                        <MessageList
                            childRef={this.childRef} // MessageInput ref
                            setReplyTo={this.setReplyTo}
                            replyTo={this.state.replyTo}
                            company={company}
                            conversation={conversation}
                            showSearchDiv={showSearchDiv}
                            showMediaViewDiv={showMediaViewDiv}
                            messages={messages}
                            messagesTotalNumber={messagesTotalNumber}
                            loadingOlderMessages={loadingOlderMessages}
                            openImageViewer={this.openImageViewer}
                            loadOlderMessages={loadOlderMessages}
                            user={user}
                            templates={templates}
                            updateTemplates={this.updateTemplates}
                            readOnly={readOnly}
                        />
                    </div>
                    {!readOnly && (
                        <div>
                            {sugTemplates.length > 0 && (
                                <div
                                    key={sugTemplates.map(t => t.id).join('-')}
                                    className="sug-templates-container"
                                >
                                    {sugTemplates.map((item, index) => (
                                        <div
                                            key={`${item.id}-${index}`}
                                            id={`sug-template-${index}`}
                                            onClick={() => this.callChildFunction(item.text)}
                                            className={`sug-templates-item ${this.state.activeIndex === index ? 'active' : ''}`}
                                        >
                                            {item.text}
                                        </div>
                                    ))}
                                </div>
                            )}


                            <div className="message-input-wrapper">
                                <MessageInputWithRef
                                    setReplyTo={this.setReplyTo}
                                    replyTo={this.state.replyTo}
                                    ref={this.childRef}
                                    setSugTemplates={this.setSugTemplates}
                                    conversation={conversation}
                                    tariff={tariff}
                                    sendChatMessage={sendChatMessage}
                                    user={user}
                                    templates={templates}
                                    confirmAction={confirmAction}
                                    addNotification={addNotification}
                                    hotkeys={hotkeys}
                                />
                            </div>
                        </div>
                    )}
                    {readOnly && (
                        <div style={{display: 'flex'}}>
                            <BlueButton
                                styles={{
                                    fontSize: '12px',
                                    margin: '20px'
                                }}
                                width={'92%'}
                                onClick={async () => {
                                    try {
                                        await moveConversationToManagedList(conversation.id, user.platformId, false);
                                        window.location.href = '/dashboard/chat/all';
                                    } catch (error) {
                                        addNotification('somethingWentWrong', config.notificationLevels.error);
                                    }
                                }}
                            >
                                <Translate text={'moveToChatList'}/>
                            </BlueButton>

                            <BlueButton
                                styles={{
                                    fontSize: '12px',
                                    margin: '20px'
                                }}
                                width={'92%'}
                                onClick={async () => {
                                    try {
                                        await moveConversationToManagedList(conversation.id, user.platformId, true);
                                        window.location.href = '/dashboard/chat/all';
                                    } catch (error) {
                                        addNotification('somethingWentWrong', config.notificationLevels.error);
                                    }
                                }}
                            >
                                <Translate text={'moveToChatList(silentMod)'}/>
                            </BlueButton>
                        </div>
                    )}
                </div>
                {isImageViewerOpen && (
                    <ImagesViewer
                        images={this.getAttachments(FileMapper.image)}
                        photoIndex={imageViewerPhotoIndex}
                        close={this.closeImageViewer}
                    />
                )}
                {isVideoViewerOpen && <VideoViewer close={this.closeVideoViewer} video={videoAttachment}/>}
            </div>
        );
    }
}

const NoConversationSelectedView = ({openContactList}) => (
    <div className="start-conversation full-height centered-flex-container">
        <ChatIcon width="130px" height="110px"/>
        <Hidden smDown>
            <p style={{fontSize: '22px', color: 'rgb(4, 62, 92)', paddingTop: '10px'}}>
                <Translate text="selectUserToStartChat"/>
            </p>
        </Hidden>
        <Hidden mdUp>
            <button style={{color: 'rgb(4, 62, 92)'}} type="button" className="no-style-button temporary-drawer-toggle"
                    onClick={openContactList}>
                <Translate text="selectUserToStartChat"/>
            </button>
        </Hidden>
    </div>
);

NoConversationSelectedView.propTypes = {
    openContactList: PropTypes.func.isRequired,
};

Conversation.propTypes = {
    user: PropTypes.object.isRequired,
    conversation: PropTypes.object,
    loadOlderMessages: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    showSideBar: PropTypes.bool,
    hasBackButton: PropTypes.bool,
    sendChatMessage: PropTypes.func,
    endConversation: PropTypes.func,
    openForwardDialog: PropTypes.func,
    openContactList: PropTypes.func,
    onUnMount: PropTypes.func,
};

Conversation.defaultProps = {
    readOnly: false,
    showSideBar: true,
    sendChatMessage: dummyTrue,
    endConversation: dummyTrue,
    openForwardDialog: dummyTrue,
    openContactList: dummyTrue,
    onUnMount: dummyTrue,
};

const mapDispatchToProps = dispatch => ({
    addNotification: (message, level, config) => {
        dispatch(addNotificationAction(message, level, config));
    },
});

export default connect(null, mapDispatchToProps)(Conversation);





// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/Conversation.jsx